import { render, staticRenderFns } from "./main.vue?vue&type=template&id=bec67164"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bec67164')) {
      api.createRecord('bec67164', component.options)
    } else {
      api.reload('bec67164', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=bec67164", function () {
      api.rerender('bec67164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customerSelect/main.vue"
export default component.exports